import styled, { css } from 'styled-components'

import { SECONDARY_NORMAL_COLOR, GREY_LIGHT_COLOR } from '@CSSVars/colors'


const secondaryMixin = css`
  font-family: var(--secondary-font), sans-serif;
`

const withSeoTextMixin = css`
  padding-bottom: 0.25rem;
  flex-direction: column;
  margin: 0;
  @media screen and (max-width: 43.9rem) {
    padding-bottom: 0;
  }
`

export const _SectionHeader = styled.div.attrs({ className: 'container' })`
  margin: 0 0 1rem;
  color: ${SECONDARY_NORMAL_COLOR};
  display: flex;
  flex-wrap: wrap;
  text-transform: capitalize;
  width: ${(props) => (!props.withSeo ? '100%' : 'initial')};
  @media screen and (max-width: 350px) {
    flex-direction: column;
  }
  align-items: center;
  gap: 0.5rem;

  ${(props) => (props.withSeo ? withSeoTextMixin : '')};
  ${(props) => (props.secondary ? secondaryMixin : '')};
  ${(props) => (props.customCss || '')};
`

export const _Title = styled.div.attrs({ className: 'title' })`
  font-size: 22px;
  margin-right: 0.5rem;
`

export const _SeoText = styled.div.attrs({ className: 'seoText' })`
  opacity: 0.7;
  font-weight: 300;
  text-transform: initial;
  transform: translateY(2px);
  font-size: 0.9rem;
  color: ${GREY_LIGHT_COLOR};
  padding: 0.25rem 0;
  line-height: 1rem;
  margin: 0;
`
